const messages_es = require('./messages.json')
export default messages_es